import {
  Form,
  Input,
  Checkbox,
  Link,
  Button,
  Space,
  Image,
  Modal,
} from '@arco-design/web-react';
import { FormInstance } from '@arco-design/web-react/es/Form';
import { IconLock, IconMobile, IconUser } from '@arco-design/web-react/icon';
import React, { useEffect, useRef, useState } from 'react';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import { auth } from '@/request/api';
import { PageTypeRegister, PageTypeResetPassword } from './constants';
import Logo from '@/assets/logo.jpg';
export default function LoginForm(props: {
  onTypeChange?: (arg: number) => void;
  userAgreemtnProtocol?: string;
  privacyPolicyProtocol?: string;
}) {
  const formRef = useRef<FormInstance>();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginParams, setLoginParams, removeLoginParams] =
    useStorage('loginParams');
  const [checked, setChecked] = useState(false);

  const [hasUserProtocol, setHasUserProtocol] = useState(false);
  const [hasPrivacyProtocol, setHasPrivacyProtocol] = useState(false);

  const [rememberPassword, setRememberPassword] = useState(!!loginParams);

  function afterLoginSuccess(params, accessToken) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    }
    // 记录登录状态
    localStorage.setItem('token', accessToken);
    // 跳转首页
    window.location.href = '/';
  }

  function login(params) {
    setErrorMessage('');
    setLoading(true);
    auth(params)
      .then((resp) => {
        if (resp.code === 200) {
          afterLoginSuccess(params, resp.data.token);
        } else {
          setErrorMessage(resp.message || '登录失败，请稍后重试');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmitClick() {
    formRef.current.validate().then((values) => {
      if (!checked) {
        Modal.confirm({
          title: '提示',
          content: (hasUserProtocol || hasPrivacyProtocol) && (
            <div style={{ display: 'flex' }}>
              <div style={{ color: '#444' }}>
                请您阅读并同意
                {hasUserProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewUserAgreementProtocol}
                  >
                    《用户协议》
                  </Link>
                )}
                {hasUserProtocol && hasPrivacyProtocol && '和'}
                {hasPrivacyProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewPrivacyPolicyProtocol}
                  >
                    《隐私政策》
                  </Link>
                )}
              </div>
            </div>
          ),
          okText: '已阅读并同意',
          onOk() {
            setChecked(true);
            login(values);
          },
        });
      } else {
        login(values);
      }
    });
  }
  const ViewUserAgreementProtocol = () => {
    Modal.info({
      icon: null,
      title: '用户协议',
      content: (
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            textAlign: 'left',
          }}
          dangerouslySetInnerHTML={{
            __html: props.userAgreemtnProtocol || '暂无用户协议',
          }}
        ></div>
      ),
    });
  };

  const ViewPrivacyPolicyProtocol = () => {
    Modal.info({
      icon: null,
      title: '隐私政策',
      content: (
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            textAlign: 'left',
          }}
          dangerouslySetInnerHTML={{
            __html: props.privacyPolicyProtocol || '暂无隐私政策',
          }}
        ></div>
      ),
    });
  };

  // 读取 localStorage，设置初始值
  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);
    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);

  useEffect(() => {
    if (
      props.userAgreemtnProtocol &&
      props.userAgreemtnProtocol != '<p></p>' &&
      props.userAgreemtnProtocol != '<p><br></p>'
    ) {
      setHasUserProtocol(true);
    } else {
      setHasUserProtocol(false);
    }

    if (
      props.privacyPolicyProtocol &&
      props.privacyPolicyProtocol != '<p></p>' &&
      props.privacyPolicyProtocol != '<p><br></p>'
    ) {
      setHasPrivacyProtocol(true);
    } else {
      setHasPrivacyProtocol(false);
    }
  }, [props.userAgreemtnProtocol, props.privacyPolicyProtocol]);

  useEffect(() => {
    if (!hasUserProtocol && !hasPrivacyProtocol) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [hasUserProtocol, hasPrivacyProtocol]);

  useEffect(() => {
    if (!hasUserProtocol && !hasPrivacyProtocol) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [hasUserProtocol, hasPrivacyProtocol]);

  return (
    <div className={styles['login-form-wrapper']}>
      {/* <div className={styles['login-form-title']} style={{ textAlign: 'left' }}>
        账号登录
      </div> */}
      <div className={styles['login-form-error-msg']}>{errorMessage}</div>
      <Form
        className={styles['login-form']}
        layout="vertical"
        ref={formRef}
        initialValues={{ account: '', password: '' }}
      >
        <Form.Item
          field="account"
          label={
            <span
              style={{ color: '#1d4e84', fontSize: 16, fontWeight: 'bold' }}
            >
              账号
            </span>
          }
          requiredSymbol={false}
          rules={[{ required: true, message: '请输入注册手机号' }]}
        >
          <Input
            prefix={<IconMobile style={{ color: '#1d4e84', fontSize: 20 }} />}
            placeholder="请输入注册手机号"
            minLength={11}
            maxLength={11}
            onPressEnter={onSubmitClick}
            className={styles['login-form-input']}
          />
        </Form.Item>
        <Form.Item
          field="password"
          label={
            <span
              style={{ color: '#1d4e84', fontSize: 16, fontWeight: 'bold' }}
            >
              密码
            </span>
          }
          requiredSymbol={false}
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Input.Password
            prefix={<IconLock style={{ color: '#1d4e84', fontSize: 20 }} />}
            placeholder="请输入密码"
            onPressEnter={onSubmitClick}
            className={styles['login-form-input']}
          />
        </Form.Item>
        <div
          style={{
            width: '100%',
            marginTop: '-10px',
            marginBottom: '10px',
            // margin: '0 0 10px 0',
          }}
        >
          <Space
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            {/* <Button
              type="text"
              long
              className={styles['login-form-register-btn']}
              onClick={() => {
                props.onTypeChange(PageTypeRegister);
              }}
            >
              立即注册
            </Button> */}
            <Button
              type="text"
              long
              className={styles['login-form-register-btn']}
              onClick={() => {
                props.onTypeChange(PageTypeResetPassword);
              }}
            >
              忘记密码？
            </Button>
          </Space>
        </div>
        <Space size={16} direction="vertical">
          <Button
            type="primary"
            long
            onClick={onSubmitClick}
            loading={loading}
            style={{
              background: '#1d4e84',
            }}
          >
            登录
          </Button>
        </Space>
        <div
          style={{
            width: '100%',
            marginTop: '16px',
          }}
        >
          {/* <Space> */}

          {(hasUserProtocol || hasPrivacyProtocol) && (
            <div style={{ display: 'flex' }}>
              <div className={styles['login-form-agree-checkbox']}>
                <Checkbox
                  checked={checked}
                  onChange={setChecked}
                  style={{ marginRight: 10 }}
                />
              </div>
              <div style={{ color: '#444' }}>
                我已阅读并同意
                {hasUserProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewUserAgreementProtocol}
                  >
                    《用户协议》
                  </Link>
                )}
                {hasUserProtocol && hasPrivacyProtocol && '和'}
                {hasPrivacyProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewPrivacyPolicyProtocol}
                  >
                    《隐私政策》
                  </Link>
                )}
              </div>
            </div>
          )}
          {/* </Space> */}
        </div>
      </Form>
    </div>
  );
}
